import styles from "./spinner.module.css";

/** A small busy indicator. The design system has none yet — kept thin until it does. */
export function Spinner({ label = "Arbetar" }: { label?: string }) {
  return <span className={styles.spinner} role="status" aria-label={label} />;
}
